module.exports = __webpack_public_path__ + "static/img/cinemaPlanRight.f19d96f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cinemaPlanRight.png
// module id = tS4S
// module chunks = 2